import { render } from "./ProductFlagLabels.vue?vue&type=template&id=74b070b6&scoped=true"
import script from "./ProductFlagLabels.vue?vue&type=script&lang=js"
export * from "./ProductFlagLabels.vue?vue&type=script&lang=js"

import "./ProductFlagLabels.vue?vue&type=style&index=0&id=74b070b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b070b6"]])

export default __exports__